import { AddIcon, GiftIcon, SendIcon } from '@treams/treams-icons';
import { Button } from '@treams/treams-ui';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import * as graphql from 'generated/graphql';

import useFeature from '../packages/kakapo-ui-application/hooks/useFeature';

export default function UserFeedbackButtons(props: { user?: graphql.User }) {
	const { t } = useTranslation();
	const hasCompliments = useFeature('2021.compliments');
	const canRequestFeedback = useFeature('2021.feedback.adhoc');
	const canGiveFeedback = useFeature('2023.feedback.spontaneous');

	if (!props.user) {
		return null;
	}

	return (
		<>
			{props.user.viewerCanRequestFeedback && canRequestFeedback && (
				<Box mb={2}>
					<Button
						icon={<AddIcon />}
						title={t('user.feedback.index.new', { name: props.user.firstName })}
						link={`/users/${props.user.id}/feedback/request-from-moment`}
					/>
				</Box>
			)}

			{canGiveFeedback && (
				<Box mb={2}>
					<Button
						type="secondary"
						icon={<SendIcon />}
						title={t('user.feedback.index.spontaneous', { name: props.user.firstName })}
						link={`/users/${props.user.id}/feedback/send`}
					/>
				</Box>
			)}

			{hasCompliments && (
				<Button
					type="secondary"
					icon={<GiftIcon />}
					title={t('user.compliments.index.new', { name: props.user.firstName })}
					link={`/users/${props.user.id}/feedback/compliments/new`}
				/>
			)}
		</>
	);
}
